import SummarySvc from '@/services/SummarySvc';
import { rowsFromSummary } from './summaryCompareCatalog';
import { requestFor } from './summaryCompareModel';

// Aturan sama kayak fetchSummaryRollup di store: rollup belum ngelayanin empat ini.
const EXCLUDED = ['gateway', 'limitswitch', 'power', 'powermeter'];

export function devcTypesOf(asset) {
  return Array.from(new Set(((asset && asset.devices) || []).map((d) => d.devcType)))
    .filter((type) => type && !EXCLUDED.includes(type));
}

export async function fetchSide(asset, range, nowMs) {
  const devcType = devcTypesOf(asset);
  if (!devcType.length) return { status: 'noDevices', rows: [], notServed: [] };

  const req = requestFor(asset.massId, range, nowMs);
  // Rentang cacat (mis. custom start >= end, atau seluruhnya di masa depan kepotong ke `now`)
  // -- sama kayak guard di buildFetchPlan (customChartModel.js), jangan kirim request sama sekali.
  if (req.startSec >= req.endSec) return { status: 'noDevices', rows: [], notServed: [] };
  try {
    const res = await SummarySvc.getAssetSummaryRollup({
      devcMassId: asset.massId, devcType, start: req.startSec, end: req.endSec,
    });
    // Tipe di `unavailable` GAK ADA di body, dan itu beda dari nol.
    const unavailable = (res && res.data && res.data.meta && res.data.meta.unavailable) || [];
    const body = (res && res.data && res.data.data) || {};
    const { rows, notServed } = rowsFromSummary(body, unavailable);
    return { status: 'ok', rows, notServed };
  } catch (e) {
    console.warn('[summary compare] rollup gagal', e && e.message);
    return { status: 'failed', rows: [], notServed: [] };
  }
}
